<script setup>
import { inject } from 'vue'

import { getProgressTableHeaderCellDisplayValue } from '@/utils/element-progress'
import { TARGET_PERIOD_ENTITY_KEYS } from '@/utils/entity-keys'
import { currentModuleStateInjectionKey } from '@/utils/injection-keys'

defineOptions({
  name: 'ProgressModuleGridHeader'
})

defineProps({
  periods: {
    type: Array,
    default: () => []
  }
})

const currentModuleState = inject(currentModuleStateInjectionKey, {})
</script>

<template>
  <div class="pmgh-Header">
    <div
      v-for="item in periods"
      :key="item[TARGET_PERIOD_ENTITY_KEYS.START_DATE]"
      :class="{
        'pmgh-Header_Cell-active': item.isActive
      }"
      :style="{
        flex: item.duration
      }"
      class="pmgh-Header_Cell"
    >
      {{
        getProgressTableHeaderCellDisplayValue({
          cellData: item,
          granulationId: currentModuleState.currentGranulationId
        })
      }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.pmgh-Header {
  display: flex;
  border-bottom: var(--pm-head-border-bottom-size, var(--cdpm-divider-size)) solid
    var(--cdpm-divider-color);
  height: var(--cdpm-header-height);
}

.pmgh-Header_Cell {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: $fs-12;
  line-height: 20px;

  &:not(&-active) {
    color: $dark-2;
    font-weight: fw('medium');
  }

  &-active {
    color: $primary-color-next;
    font-weight: fw('bold');
  }

  &:not(:last-child) {
    box-shadow: inset calc(-1 * var(--cdpm-divider-size)) 0 0 var(--cdpm-divider-color);
  }
}
</style>
